import React from 'react'
import { connect } from 'react-redux'
import './progress-bar.scss'
import { CircularProgressbar } from 'react-circular-progressbar'


const defaultSqSizeMap = {
	'mobile': 30,
	'web': 27
}

const ThumbnailProgressBar = props => {
	// Size of the enclosing square
	const defaultSqSize = defaultSqSizeMap[props.isMobile ? 'mobile' : 'web'];
	const sqSize = props.sqSize || defaultSqSize;
	// Enclose cicle in a circumscribing square
	const viewBox = `0 0 ${sqSize} ${sqSize}`

	return (
		<div className='circular-wrapper' onClick={(e) => {
			props.onClick && props.onClick(e)
		}}>
			<div className='back-icon icon-videoCam' style={sqSize !== defaultSqSize ? {
				fontSize: '1.8rem'
			}: null}></div>
			<CircularProgressbar
				value={100 - props.percentage}
				strokeWidth={props.strokeWidth}
				counterClockwise
				styles={{
					root: {
						width: sqSize,
						height: sqSize,
						viewBox: viewBox
					},
					path: {
						stroke: 'rgba(0,0,0,0.5)',
						strokeLinecap: 'butt'
					},
					trail: {
						stroke: 'transparent'
					},

				}}
			/>
		</div>
	)
}
ThumbnailProgressBar.defaultProps = {
	// sqSize: 30,
	percentage: 0,
	strokeWidth: 50,
}

const mapStateToProps = (state, props) => {
	const newState = {
		videoData: state.videoupload.videos[props.videoKey] || {},
		isMobile: state.library.deviceData.isMobile
	}
	newState.percentage = newState.videoData.progress || 0;
	return newState;
}

export default connect(mapStateToProps, {})(ThumbnailProgressBar)
